<template>
  <v-breadcrumbs
    :items="items"
    class="pl-2"
  >
    <template v-slot:divider>
      <v-icon>mdi-chevron-right</v-icon>
    </template>
    <template v-slot:item="{ item }">
      <span class="body secondary300">
        <router-link
          v-if="!item.disabled"
          :to="{name: item.to, params: backRoute == item.to ? backParams : {}}"
        >
          {{ item.text }}
        </router-link>
        <div v-else>
          {{ item.text }}
        </div>
      </span>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'BreadCrumbs',
  props: {
    backParams: {
      type: Object,
      default: () => {},
    },
    backRoute: {
      type: String,
      default: '',
    },
  },
  computed: {
    items() {
      return this.$route.meta?.breadcrumbs || [];
    },
  },
};
</script>
